

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import { Deployment, Service } from '@/types';
import UpimportInfoDialog from './InfoDialogs/UpimportInfoDialog.vue';
import UpaffiliateInfoDialog from './InfoDialogs/UpaffiliateInfoDialog.vue';

@Component({
  name: 'info-dialog',
  components: {
    UpimportInfoDialog,
    UpaffiliateInfoDialog
  }
})
export default class InfoDialog extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  deployment!: Deployment;

  @Prop({ required: true })
  service!: Service;

  closeDialog() {
    this.$emit('close');
  }
}
